import { useQuery } from '@tanstack/react-query';
import { GetCustomizedDocumentTypesResponse } from '@ab/ams-school-api/src/services/studentDocuments/v1/customization/types';
import { useRequest } from '~/lib/useRequest';
import { config } from '~/config';
import { hasKey } from '~/utils';

export function useGetCustomizedDocumentTypes() {
  const request = useRequest();

  const { data, error, isLoading } = useQuery(
    ['customized_document_types'], // Unique query key
    async () => {
      const response = await request<GetCustomizedDocumentTypesResponse>(
        `${config.apiHost}/private/v1/customized_document_types`,
        {
          method: 'GET',
          isExpectedResponse: isExpectedGetCustomizedDocumentTypesResponse,
        }
      );
      return response;
    }
  );

  return {
    customizedDocumentTypes: data?.data,
    getCustomizedDocumentTypesError: error,
    isFetchingCustomizedDocumentTypes: isLoading,
  };
}

function isExpectedGetCustomizedDocumentTypesResponse(res: unknown): res is GetCustomizedDocumentTypesResponse {
  return Boolean(res && typeof res === 'object' && hasKey('data', res));
}
